import { allPackagesCalculatedEvent } from './package-calculator';
import PackageComparingModal, { MODE_COMPARE, MODE_DETAIL } from './package-comparing-modal';

export default class PackageComparing {
  constructor(options = {}) {
    ({ sorter: this.sorter, filter: this.filter } = options);

    this.compareOverlayButton = document.getElementById('package-compare-button');
    this.moreInfoLinkOutput = document.querySelectorAll(".package-more-info-output");
    this.allPackagesCalculated = false;
    this.compareEnabled = false;

    this.init();
  }

  init() {
    document.addEventListener(allPackagesCalculatedEvent, () => {
      this.allPackagesCalculated = true;
      this.enableCompareButton();
      this.createMoreInfoLinks();
    });

    this.filter.onFilter(activePackageIds => {
      if (!this.allPackagesCalculated) {
        return;
      }

      if (activePackageIds.length === 0) {
        this.disableCompareButton();
      } else {
        this.enableCompareButton();
      }
    });

    if (this.compareOverlayButton) {
      this.compareOverlayButton.addEventListener('click', e => {
        e.preventDefault();

        if (!this.compareEnabled) {
          return;
        }

        if (this.compareOverlayButton) {
          const compareModal = new PackageComparingModal({
            mode: MODE_COMPARE,
            href: this.compareOverlayButton.dataset.href,
            packageIds: this.getPackageIds()
          });

          compareModal.openModal();
        }
      });
    }
    return this;
  }

  getPackageIds() {
    if (!this.filter || !this.sorter) {
      return [];
    }
    return [...this.sorter.packageIdsSorted].filter(id => this.filter.activePackageIds.includes(id));
  }

  enableCompareButton() {
    this.compareEnabled = true;
    if (this.compareOverlayButton) {
      this.compareOverlayButton.disabled = false;
    }
  }

  disableCompareButton() {
    this.compareEnabled = false;
    if (this.compareOverlayButton) {
      this.compareOverlayButton.disabled = true;
    }
  }

  createMoreInfoLinks() {
    for (const output of this.moreInfoLinkOutput) {
      const a = document.createElement("a");
      a.setAttribute("href", output.dataset.href);
      a.dataset.packageId = output.dataset.packageId;
      a.innerHTML = output.dataset.content;

      output.innerHTML = "";
      output.append(a);

      a.addEventListener("click", function (e) {
        e.preventDefault();

        const compareModal = new PackageComparingModal({
          mode: MODE_DETAIL,
          href: this.href,
          packageIds: [this.dataset.packageId]
        });

        compareModal.openModal();

        return false;
      });
    }
  }
}
